import React from "react";
import { string, bool, func } from "prop-types";
import { PriceTypeDropdownCommon } from "./PriceTypeDropdownCommon";

export const PriceTypeDropdownSimple = (props: any) => {
  return (
    <PriceTypeDropdownCommon
      componentLabel={props.componentLabel}
      defaultValue={props.defaultValue}
      showAll={props.showAll}
      onChange={props.onChange}
      countryCode={props.countryCode}
      visualStyle="autoComplete"
    />
  );
};

PriceTypeDropdownSimple.propTypes = {
  componentLabel: string,
  defaultValue: string,
  showAll: bool,
  onChange: func,
};
